const flippedSupportedPMs = {
    R: 'BILL',
    BS: 'DIRECT_DEBIT_SEPA',
    ID: 'IDEAL',
    AP: 'APPLE_PAY',
    BC: 'BANCONTACT',
    BM: 'BANCONTACT_MOBILE',
    CD: 'CASH_ON_DELIVERY',
    K: 'CREDIT_CARD',
    DP: 'DOTPAY',
    OP: 'ONLINE_BANKING_PL',
    MB: 'MULTIBANCO',
    PP: 'PAYPAL',
    PT: 'PAYTRAIL',
    VK: 'PREPAYMENT',
    TY: 'TRUSTLY',
    TW: 'TWINT',
    KL: 'KLARNA_PAY_LATER',
    KO: 'KLARNA_PAY_OVER_TIME',
};
const bancontactPaymentMethods = ['BC', 'BM'];
const cardTypeOfCreditCardBrand = {
    MASTER_CARD: 'mastercard',
    VISA: 'visa',
    DINERS_CLUB: 'diners-club',
    AMERICAN_EXPRESS: 'american-express',
    MAESTRO: 'maestro',
    CARTE_BANCAIRE: 'cartebancaire',
    OTHER: null,
};
const creditCardBrandOfCardType = {
    mastercard: 'MASTER_CARD',
    visa: 'VISA',
    'diners-club': 'DINERS_CLUB',
    'american-express': 'AMERICAN_EXPRESS',
    maestro: 'MAESTRO',
    cartebancaire: 'CARTE_BANCAIRE',
    discover: 'OTHER',
    jcb: 'OTHER',
    unionpay: 'OTHER',
    elo: 'OTHER',
    mir: 'OTHER',
    hiper: 'OTHER',
    hipercard: 'OTHER',
    cartebancontact: 'OTHER',
};

export { bancontactPaymentMethods, cardTypeOfCreditCardBrand, creditCardBrandOfCardType, flippedSupportedPMs };
//# sourceMappingURL=ModernizePaymentTypes.js.map
